<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            <back-button link="/main/employees"></back-button> 
            Update employee: {{ form.id }}<loading :isLoading="isLoading"></loading>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li><router-link to="/main/employees">Employees</router-link></li>
            <li class="active">Update</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-md-6">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-12 col-xs-12">
                    <div class="form-wrap form-horizontal">
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Full Name*</label>
                        <div class="col-sm-9">
                          <input v-uppercase type="text" class="form-control" placeholder="Full Name" v-model="form.full_name">
                          <span class="error-block">{{ errors.full_name }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Email*</label>
                        <div class="col-sm-9">
                          <input v-uppercase type="text" class="form-control" placeholder="Email" v-model="form.email">
                          <span class="error-block">{{ errors.email }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label"></label>
                        <div class="col-sm-9">
                          <my-checkbox :selection.sync="form.active" placeholder="Is Active"></my-checkbox>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Role</label>
                        <div class="col-sm-9">
                          <my-select :selection.sync="form.role_id" :suggestions="roles" placeholder="Enter Role"></my-select>
                          <span class="error-block">{{ errors.role_id }}</span>
                        </div>
                      </div>
                      <div class="form-group mb-0">
                        <div class="col-sm-offset-3 col-sm-9">
                          <submit-button :isLoading="isLoading" @submit="update" text="Update"></submit-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>

  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'employeeUpdate',
  data () {
    return {
      form: {
        role_id: ''
      },
      roles: [],
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
    this.getMasters()
  },
  methods: {
    async getMasters() {
      let masters = await axios.get('users/masters')
      masters = masters.data
      masters.roles.forEach(role => {
        this.roles.push({
          id: role.id,
          name: role.name
        })
      })
    },
    async getData() {
      this.isLoading = true
      let form = await axios.get(`/users/${this.$route.params.employeeId}`)
      this.form = form.data.data
      this.form.roles.length > 0 ? this.form.role_id = this.form.roles[0].id : this.form.role_id = ''
      this.isLoading = false
    },
    async update() {
      try {
        this.isLoading = true
        await axios.patch(`/users/${this.$route.params.employeeId}`, this.form)
        this.isLoading = false
        this.$router.push('/main/employees')
      } catch(e) {
        this.isLoading = false
      }
    }
  }
}
</script>